import React, { useState } from 'react';
import TripActionsMenu from '../actions/TripActionsMenu';
import { ArrowDownTrayIcon } from '@heroicons/react/24/solid';
import { formatDMY, formatDMYHM } from '../../utils/datetime';

const TripTable = ({ trips, handleEdit, handleStateUpdate, onTripSelected, onDownloadDocs, onDownloadManifest }) => {
  const [loadingManifest, setLoadingManifest] = useState({});

  const u = value => String(value ?? '').toUpperCase();

  const formatDateWithHHMM = (dt) => {
    if (!dt) return '';
    return formatDMYHM(dt);
  };

  const handleManifestClick = async (trip) => {
    setLoadingManifest(prev => ({ ...prev, [trip.id]: true }));
    await onDownloadManifest(trip);
    setLoadingManifest(prev => ({ ...prev, [trip.id]: false }));
  };

  return (
    <div className="hidden md:block">
      <table className="min-w-full bg-white rounded shadow text-sm">
        <thead className="bg-[#293686] text-white uppercase text-left">
          <tr>
            <th className="p-2">Trip Code</th>
            <th className="p-2">Branch</th>
            <th className="p-2">Customer</th>
            <th className="p-2">Client</th>
            <th className="p-2">Status</th>
            <th className="p-2">Vehicle</th>
            <th className="p-2">Pickup</th>
            <th className="p-2">Delivery</th>
            <th className="p-2">Placement Date</th>
            <th className="p-2">Created Date</th>
            <th className="p-2 text-center">Manifest</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {trips.length > 0 ? (
            trips.map((trip, idx) => (
              <tr key={idx} className="border-t">
                <td className="p-2 text-[#E91C24] font-bold">
                  <div className="cursor-pointer" onClick={() => onTripSelected(trip)}>
                    {u(trip.trip_code)}
                  </div>
                </td>
                <td className="p-2">{u(trip.branch?.name)}</td>
                <td className="p-2">{u(trip.customer?.name)}</td>
                <td className="p-2">{u(trip.client?.name)}</td>
                <td className="p-2">{u(trip.status)}</td>
                <td className="p-2">{u(trip.vehicle_number)}</td>
                <td className="p-2">{u(trip.expected_pickup_date ? formatDMY(trip.expected_pickup_date) + ' ' + (trip?.expected_pickup_time ?? "") : "")}</td>
                <td className="p-2">{u(trip.expected_delivery_date ? formatDMY(trip?.expected_delivery_date) + ' ' + (trip?.expected_delivery_time ?? "") : "")}</td>
                <td className="p-2">{formatDMY(trip.placement_pickup_date)}</td>
                <td className="p-2">{formatDateWithHHMM(trip.created_at)}</td>

                {/* Manifest column */}
                <td className="p-2 text-center">
                  <button
                    title="Download Manifest"
                    onClick={() => handleManifestClick(trip)}
                    disabled={loadingManifest[trip.id]}
                    className="inline-flex items-center justify-center p-1.5 rounded hover:bg-orange-50 disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    {loadingManifest[trip.id] ? (
                      <svg className="animate-spin w-4 h-4 text-orange-500" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                      </svg>
                    ) : (
                      <ArrowDownTrayIcon className="w-4 h-4 text-orange-500" />
                    )}
                  </button>
                </td>

                <td className="p-2">
                  <TripActionsMenu
                    onEdit={() => handleEdit(trip)}
                    onStateUpdate={handleStateUpdate}
                    onDownloadDocs={onDownloadDocs}
                    onDownloadManifest={onDownloadManifest}
                    trip={trip}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" className="text-center text-gray-500 py-10">
                No trips found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TripTable;
